import NavigationBlock from '../../components/blocks/navigation_block.jsx';

window.NavigationBlock = NavigationBlock;
